/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import ScrollLock from 'react-scrolllock';
import warnOnce from '@atlaskit/ds-lib/warn-once';
import { bodyStyles, wrapperStyles } from '../styles/content';
import Footer from './footer';
import Header from './header';
import ScrollContainer from './scroll-container';
const emptyObject = {};
export default function Content(props) {
  const {
    actions,
    appearance,
    body: DeprecatedBody,
    children,
    components = emptyObject,
    footer,
    header,
    heading,
    isChromeless,
    isHeadingMultiline,
    onClose,
    shouldScroll,
    testId,
    headingId,
    stackIndex
  } = props;
  const {
    Container = 'div',
    Body: CustomBody
  } = components;
  const Body = CustomBody || DeprecatedBody || 'div';

  if (process.env.NODE_ENV !== 'production') {
    if (header) {
      warnOnce("@atlaskit/modal-dialog: Deprecation warning - Use of the header prop in ModalDialog is deprecated. Please compose your ModalDialog using the 'components' prop instead");
    }

    if (footer) {
      warnOnce("@atlaskit/modal-dialog: Deprecation warning - Use of the footer prop in ModalDialog is deprecated. Please compose your ModalDialog using the 'components' prop instead");
    }

    if (DeprecatedBody) {
      warnOnce("@atlaskit/modal-dialog: Deprecation warning - Use of the body prop in ModalDialog is deprecated. Please compose your ModalDialog using the 'components' prop instead");
    }
  }

  return jsx(Container, {
    css: wrapperStyles,
    "data-modal-stack": stackIndex,
    "data-testid": testId
  }, isChromeless ? children : jsx(React.Fragment, null, jsx(Header, {
    id: headingId,
    appearance: appearance,
    component: components.Header ? components.Header : header,
    heading: heading,
    onClose: onClose,
    isHeadingMultiline: isHeadingMultiline,
    testId: testId
  }), jsx(ScrollLock, null, jsx(ScrollContainer, {
    shouldScroll: shouldScroll,
    testId: testId
  }, jsx(Body, {
    css: bodyStyles,
    "data-testid": testId && `${testId}--body`
  }, children))), jsx(Footer, {
    actions: actions,
    appearance: appearance,
    component: components.Footer ? components.Footer : footer,
    onClose: onClose,
    testId: testId
  })));
}